export function validarPeriodoAgenda(dataInicial, dataFinal) {
  if (!dataInicial || !dataFinal) {
    return "Informe a data inicial e a data final para consultar a agenda.";
  }

  if (dataInicial > dataFinal) {
    return "A data inicial não pode ser maior que a data final.";
  }

  return null;
}
